/*
 * @Author: Teemo Ding
 * @Date: 2021-09-07 16:47:11
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 11:05:46
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseEdit/CustomerEligibleCondition/index.tsx
 */
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import Condition from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/CustomerEligibleCondition';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const _base = 'customerCondition';
export const _type = [_base, 'conditionType'];
const _customer = [_base, 'customers'];
const _tags = [_base, 'customerTags'];

const CustomerEligibleCondition = ({
  form,
  disableEdit,
  disabledEveryoneDependency,
  // onEveryoneSelected,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      className={css.sectionContainer}
      title={getI18n(
        'salesChannelDirectDiscount.eligibalCondition.customerEligibleCondition',
      )}>
      <Condition
        form={form}
        radioName={_type}
        tagsName={_tags}
        customerName={_customer}
        disableEdit={disableEdit}
        disabledEveryoneDependency={disabledEveryoneDependency}
      />
    </SectionWrapper>
  );
};
export default CustomerEligibleCondition;
